import styled from 'styled-components'
import { dynamicProps, DynamicProps } from '~/assets/styles/props'

type BoxProps = DynamicProps

export const BoxAtom = styled.div<BoxProps>`
  ${dynamicProps}
`
